var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Quiz = function Quiz(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m19.741 7.328-4.445-5a.998.998 0 0 0-.74-.328h-8C5.146 2 4 3.122 4 4.5v15C4 20.878 5.146 22 6.556 22h10.888C18.854 22 20 20.878 20 19.5V8a.998.998 0 0 0-.259-.672ZM14 3.978 17.742 8h-3.028C14.32 8 14 7.619 14 7.15V3.978Zm-2.293 6.315a1 1 0 0 1 0 1.414l-2 2a1 1 0 0 1-1.414 0l-1-1a1 1 0 1 1 1.414-1.414l.293.293 1.293-1.293a1 1 0 0 1 1.414 0ZM17 13a1 1 0 0 1-1 1h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 1 1Zm-4 5h3a1 1 0 0 0 0-2h-3a1 1 0 0 0 0 2Zm-1.293-2.293a1 1 0 0 0-1.414-1.414L9 15.586l-.293-.293a1 1 0 0 0-1.414 1.414l1 1a1 1 0 0 0 1.414 0l2-2Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Quiz;